module.exports = __webpack_public_path__ + "static/media/publish-header.fa826689.jpg";